export const products = [
  {
    id: '6ru-19-eziblank-black-box-10',
    slug: '6ru-19-eziblank-black-box-10',
    name: '6RU 19" EziBlank Blanking Panels - Black',
    description: '6RU 19" EziBlank Blanking Panels/Box of 10 Panels - BLACK, UL Approved',
    quantity: '136 Boxes / Full Pallet',
    price: 184,
    image: '/products/324_1_.jpg',
  },
  {
    id: '6ru-19-eziblank-white-box-10',
    slug: '6ru-19-eziblank-white-box-10',
    name: '6RU 19" EziBlank Blanking Panels - White',
    description: '6RU 19" EziBlank Blanking Panels/Box of 10 Panels - WHITE, UL Approved',
    quantity: '136 Boxes / Full Pallet',
    price: 195,
    image: '/products/479.jpg',
  },
  {
    id: '6ru-19-universal-eziblank-black-box-10',
    slug: '6ru-19-universal-eziblank-black-box-10',
    name: '6RU 19" Universal EziBlank Blanking Panels - Black',
    description: '6RU 19" Universal EziBlank Blanking Panels/Box of 10 Panels - BLACK, UL Approved',
    quantity: '104 Boxes / Full Pallet',
    price: 195,
    image: '/products/422_1.jpg',
  },
  {
    id: '6ru-19-universal-eziblank-white-box-10',
    slug: '6ru-19-universal-eziblank-white-box-10',
    name: '6RU 19" Universal EziBlank Blanking Panels - White',
    description: '6RU 19" Universal EziBlank Blanking Panels/Box of 10 Panels - WHITE, UL Approved',
    quantity: '104 Boxes / Full Pallet',
    price: 212,
    image: '/products/479.jpg',
  },
  {
    id: '6ru-23-universal-eziblank-black-box-10',
    slug: '6ru-23-universal-eziblank-black-box-10',
    name: '6RU 23" Universal EziBlank Blanking Panels - Black',
    description: '6RU 23" Universal EziBlank Blanking Panels/Box of 10 Panels - BLACK, UL Approved',
    quantity: '78 Boxes / Full Pallet',
    price: 240,
    image: '/products/BKPNL02U-23-01.png',
  },
  {
    id: '1ru-horizontal-air-management-brush-19-pack-5',
    slug: '1ru-horizontal-air-management-brush-19-pack-5',
    name: '1RU Horizontal Air Management Brush - Black',
    description: '1RU horizontal air management brush suitable for 19" server racks, Pack of 5 with attachment hardware included - Black',
    quantity: 'Box of 25 packs',
    price: 185,
    image: '/products/brushpanel-close-up.jpg',
  },
  {
    id: '10su-21-universal-eziblank-black',
    slug: '10su-21-universal-eziblank-black',
    name: '10-SU 21" Universal EziBlank Blanking Panels - Black',
    description: '10-SU 21" Universal EziBlank Blanking Panels, 100-SU per box, BLACK, UL Approved',
    quantity: '104 Boxes / Full Pallet',
    price: 270,
    image: '/products/475-scaled.jpg',
  },
  {
    id: 'eziwall-half-sized-stackable-air-flow-barrier',
    slug: 'eziwall-half-sized-stackable-air-flow-barrier',
    name: 'Half-sized Stackable Air Flow Barrier - Black',
    description: 'Half-sized stackable air flow barrier that can be positioned anywhere, 2-pack one wall - Black, 23RU x 47.2" x 39.4" x 3.1"',
    quantity: '1 Pack / 2 Panels',
    price: 325,
    image: '/products/EZWM23UPNL02-04.png',
  },
  {
    id: 'angle-anchor-ezw-23u-eziwall-4-pack',
    slug: 'angle-anchor-ezw-23u-eziwall-4-pack',
    name: 'Angle Anchor for EZW-23U EziWall',
    description: 'Angle Anchor for EZW-23U EziWall, 4 Pack',
    quantity: '1 Pack / 4 Angles',
    price: 90,
    image: '/products/angles-new-1517x2048-1.jpg',
  },
  {
    id: 'below-rack-24-magnetic-brush',
    slug: 'below-rack-24-magnetic-brush',
    name: 'Below Rack 24" Magnetic Brush',
    description: 'Below rack 24" MAGNETIC brush',
    quantity: '1 Pack / 2 Panels',
    price: 90,
    image: '/products/brushpanel-close-up.jpg',
  },
];

export const findProductBySlug = (slug) =>
  products.find((p) => p.slug === slug);
